import { colors } from 'theme'

export const defaultThemeStyles = {
    text: colors.white,
    levelContent: colors.blackLight,
    levelActive: colors.darkCloud,
    levelPointer: colors.white,
}
